import { v4 as uuidv4 } from 'uuid'

const data = [
  {
    id: uuidv4(),
    text: 'Nairobi CBD',
  },
  {
    id: uuidv4(),
    text: 'Along Mombasa Road all the way to Kitengela',
  },
  {
    id: uuidv4(),
    text: 'Jogoo road all the way to Donhom',
  },
  {
    id: uuidv4(),
    text: 'Ngong road all the way to Ngong town and Karen',
  },
  {
    id: uuidv4(),
    text: 'Kileleshwa',
  },
  {
    id: uuidv4(),
    text: 'Lavington',
  },
  {
    id: uuidv4(),
    text: 'Kilimani',
  },
  {
    id: uuidv4(),
    text: 'Westlands',
  },
  {
    id: uuidv4(),
    text: 'Jamhuri',
  },
  {
    id: uuidv4(),
    text: 'Kibra',
  },
  {
    id: uuidv4(),
    text: 'Langata',
  },
  {
    id: uuidv4(),
    text: 'Wilson Airport',
  },
  {
    id: uuidv4(),
    text: 'Rongai',
  },
  {
    id: uuidv4(),
    text: 'Uthiru',
  },
  {
    id: uuidv4(),
    text: 'Kikuyu',
  },
  {
    id: uuidv4(),
    text: 'Village Market',
  },
  {
    id: uuidv4(),
    text: 'Two Rivers',
  },
  {
    id: uuidv4(),
    text: 'Ruaka',
  },
  {
    id: uuidv4(),
    text: 'Banana',
  },
  {
    id: uuidv4(),
    text: 'Two Rivers Mall',
  },
  {
    id: uuidv4(),
    text: 'Kasarani',
  },
  {
    id: uuidv4(),
    text: 'Roysambu',
  },
  {
    id: uuidv4(),
    text: 'Juja',
  },
  {
    id: uuidv4(),
    text: 'Ruiru',
  },
]

export default data
